import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props { children: ReactNode }
interface State { error: Error | null; info: string | null }

/**
 * Sem isto, qualquer exceção numa tela desmonta o app inteiro e o que sobra é
 * o fundo do body — que no tema escuro é uma tela preta, sem explicação
 * nenhuma. Aqui o erro vira texto que dá para ler e copiar.
 */
export default class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('falha na tela', error, info);
    this.setState({ info: info.componentStack?.split('\n').slice(0, 4).join('\n') ?? null });
  }

  render(): ReactNode {
    const { error, info } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="center">
        <div className="login" style={{ maxWidth: 520 }}>
          <h1 style={{ margin: 0, fontSize: 20 }}>Esta tela falhou</h1>
          <p className="muted small" style={{ margin: 0 }}>
            O resto do app continua funcionando, e nada do que você escreveu foi perdido —
            os traços são salvos no aparelho antes de qualquer outra coisa.
          </p>
          <div className="transcript" style={{ whiteSpace: 'pre-wrap' }}>
            {error.message}
            {info ? `\n${info}` : ''}
          </div>
          <div className="row wrap">
            <button className="primary" onClick={() => this.setState({ error: null, info: null })}>
              Tentar de novo
            </button>
            <button onClick={() => { location.href = '/'; }}>Voltar aos cadernos</button>
            <button
              onClick={() => {
                void navigator.clipboard?.writeText(`${error.message}\n${error.stack ?? ''}\n${info ?? ''}`);
              }}
            >
              Copiar o erro
            </button>
          </div>
        </div>
      </div>
    );
  }
}
